import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes, useLocation  } from 'react-router-dom'
import './App.css';
import Login from './components/Login/Login';
import Establecimiento from './components/Establecimiento/Establecimiento';
import NotFound from './components/NotFound/NotFound';
import NotAuth from './components/NotAuth/NotAuth';
import * as Constants from './constants'; 
import { EstablishmentProvider } from './Context/EstablishmentContext';
import HttpInterceptor from './interceptors/http-interceptor';
import Habitacion from './components/Habitacion/Habitacion';
import Cama from './components/Cama/Cama';
import Personal from './components/Personal/Personal';
import NavBar from './components/NavBar/NavBar';
import Cadenas from './components/Cadena/Cadena';
import Descarga from './components/Descarga/Descarga';
import ResetPassword from './components/ResetPassword/ResetPassword';
import Password from './components/Password/Password';
import { Outlet  } from "react-router-dom";
import { Navigate  } from "react-router-dom";

import { AuthenticationService } from '../../levitup-web/src/services/authentication.service';

let userRol;
let userTipoEmpleado;

	const authenticationService = new AuthenticationService();
	if(authenticationService.getAuthenticationSession() != null) {
		userRol = authenticationService.getAuthenticationSession().user.idTipo;//obtiene el rol de usuario
		userTipoEmpleado = authenticationService.getAuthenticationSession().user.tipoEmpleado;
	} else {
		userRol = null;
		userTipoEmpleado = null;
	}
	if(userTipoEmpleado != null ){
		if(userTipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA){
			userRol = Constants.ROLE_USUARIO_TRABAJADOR_GOBERNANTA
		}
		if(userTipoEmpleado.id === Constants.TIPO_EMPLEADO_MANTENIMIENTO){
			userRol = Constants.ROLE_USUARIO_TRABAJADOR_MANT
		}
	}
	
	const RoleAccess = ({ roles = [] }) => {
	  return !roles.length || roles.includes(userRol)
	    ? <Outlet />
	    : <Navigate to={Constants.ROUTE_NOT_AUTH} replace />;
	};
	
function App() {

    useEffect(() => {
        HttpInterceptor();
        
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <EstablishmentProvider>
                	<MainContent />
                </EstablishmentProvider>
            </BrowserRouter>
        </div>
    );
}

function MainContent() {
	if(authenticationService.getAuthenticationSession() != null) {
		userRol = authenticationService.getAuthenticationSession().user.idTipo;//obtiene el rol de usuario
		userTipoEmpleado = authenticationService.getAuthenticationSession().user.tipoEmpleado;
	} else {
		userRol = null;
		userTipoEmpleado = null;
	}
	if(userTipoEmpleado != null ){
		if(userTipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA){
			userRol = Constants.ROLE_USUARIO_TRABAJADOR_GOBERNANTA
		}
		if(userTipoEmpleado.id === Constants.TIPO_EMPLEADO_MANTENIMIENTO){
			userRol = Constants.ROLE_USUARIO_TRABAJADOR_MANT
		}
		if(userTipoEmpleado.id === Constants.TIPO_EMPLEADO_RECEPCION){
			userRol = Constants.ROLE_USUARIO_TRABAJADOR_RECEPCION
		}
	}
    let location = useLocation(); // obtiene la ubicación actual
    
    return (
        <>
        <div className="MainContent">
                {/* renderiza NavBar si estamos en una ruta valida, pasando la ruta actual como prop en el NavBar */}
                {(location.pathname === Constants.ROUTE_ESTABLECIMIENTOS
                	 || location.pathname === Constants.ROUTE_HABITACIONES
                	 || location.pathname === Constants.ROUTE_CAMAS
                	 || location.pathname === Constants.ROUTE_PERSONAL
                	 || location.pathname === Constants.ROUTE_CADENAS
					 || location.pathname === Constants.ROUTE_DESCARGA)
                	 && <NavBar currentPath={location.pathname}/>}
                
                <Routes>
                    <Route path={Constants.ROUTE_ROOT} element={<Login />} />
                    
                    <Route element={<RoleAccess roles={[Constants.ROLE_USUARIO_ADMINISTRADOR, Constants.ROLE_USUARIO_ADMIN_CADENA, Constants.ROLE_USUARIO_GESTOR]} />}>
					    <Route path={Constants.ROUTE_ESTABLECIMIENTOS} element={<Establecimiento />} />
					</Route>
					
					<Route element={<RoleAccess roles={[Constants.ROLE_USUARIO_ADMINISTRADOR,Constants.ROLE_USUARIO_ADMIN_CADENA,Constants.ROLE_USUARIO_GESTOR,Constants.ROLE_USUARIO_TRABAJADOR_GOBERNANTA,Constants.ROLE_USUARIO_TRABAJADOR_RECEPCION]} />}>
					    <Route path={Constants.ROUTE_HABITACIONES} element={<Habitacion />} />
					</Route>
					
					<Route element={<RoleAccess roles={[Constants.ROLE_USUARIO_ADMINISTRADOR,Constants.ROLE_USUARIO_ADMIN_CADENA,Constants.ROLE_USUARIO_GESTOR,Constants.ROLE_USUARIO_TRABAJADOR_MANT]} />}>
					    <Route path={Constants.ROUTE_CAMAS} element={<Cama />} />
					</Route>
					
					<Route element={<RoleAccess roles={[Constants.ROLE_USUARIO_ADMINISTRADOR,Constants.ROLE_USUARIO_ADMIN_CADENA,Constants.ROLE_USUARIO_GESTOR,Constants.ROLE_USUARIO_TRABAJADOR_GOBERNANTA]} />}>
					    <Route path={Constants.ROUTE_PERSONAL} element={<Personal />} />
					</Route>
					
					<Route element={<RoleAccess roles={[Constants.ROLE_USUARIO_ADMINISTRADOR]}/>}>
						<Route path={Constants.ROUTE_CADENAS} element={<Cadenas/>} />
					</Route>
					
					<Route element={<RoleAccess roles={[Constants.ROLE_USUARIO_ADMINISTRADOR, Constants.ROLE_USUARIO_ADMIN_CADENA, Constants.ROLE_USUARIO_GESTOR, Constants.ROLE_USUARIO_TRABAJADOR_MANT]} />}>
						<Route path={Constants.ROUTE_DESCARGA} element={<Descarga/>} />
					</Route>
                   
                    
					<Route path={Constants.ROUTE_RESET_PASSWORD} element={<ResetPassword />}/>
					<Route path={Constants.ROUTE_PASSWORD} element={<Password />}/>
					<Route path={Constants.ROUTE_NOT_FOUND} element={<NotFound />}/>
					<Route path={Constants.ROUTE_NOT_AUTH} element={<NotAuth />}/>
                    
                </Routes>
     	</div>
        </>
    );
}

export default App;